export default __webpack_public_path__ + "static/media/full_architecture.08815d83.png";